import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly themeKey = 'isDark';

  // Estado reactivo con Signal
  private readonly _isDark = signal<boolean>(false);

  // Exponemos como Readonly Signal
  readonly isDark = this._isDark.asReadonly();

  constructor() {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(this.themeKey);
      const isDark = saved === 'true';
      this._isDark.set(isDark);
      this.applyTheme(isDark);
    }
  }

  toggleTheme(): void {
    this._isDark.update(value => !value); // Usamos update para invertir el valor
    const newValue = this._isDark();

    this.applyTheme(newValue);
    localStorage.setItem(this.themeKey, newValue.toString());
  }

  initializeTheme(): void {
    // La inicialización ya se hace en el constructor, pero mantenemos el método por compatibilidad
    // o por si se quiere forzar una re-aplicación
    this.applyTheme(this._isDark());
  }

  private applyTheme(isDark: boolean): void {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('dark-theme', isDark);
      document.body.classList.toggle('light-theme', !isDark);
      document.documentElement.classList.toggle('dark-theme', isDark);
      document.documentElement.classList.toggle('light-theme', !isDark);
    }
  }
}
